import { isVideoStation } from '../helpers';
import { useActiveStation } from './useActiveStation';

/**
 * Returns whether the currently active station is a video station (mpegts format).
 */
export function useIsActiveStationVideo() {
  return isVideoStation(useActiveStation());
}
